import React, {Component} from "react";
import PropTypes from "prop-types";
import {Typography, Upload, Icon, Row, Col} from "antd";

import {ReactComponent as UploadIcon} from "../assets/icons/upload-icon.svg";
import DownloadIcon from "icons/DownloadIcon";
import {displayGenericError} from "common/notifications";
import {generateUploadedFile} from "api/api";
import {FormattedMessage} from "react-intl";

import "./UploadWrapper.css";

const {Text} = Typography;
const {Dragger} = Upload;

class UploadWrapperMulti extends Component {
    handleBeforeUpload = file => {
        const isUnderLimit = file.size / 1024 / 1024 < 10; // < 10MB

        if (!isUnderLimit) {
            displayGenericError({
                message: "File size must be smaller than 10MB"
            });
        }

        return isUnderLimit;
    };

    handleUpload = ({file, onSuccess, onError}) => {
        const {upload, type, index, itemId} = this.props;
        if (itemId) {
            upload({file, type, index, itemId})
                .then(res => onSuccess(res, file))
                .catch(e => {
                    displayGenericError(e);
                    onError();
                });
        } else {
            upload({file, type, index})
                .then(res => onSuccess(res, file))
                .catch(e => {
                    displayGenericError(e);
                    onError();
                });
        }

    };

    handleDownload = (file) => {
        const {isOriginatorAttachedFile, isOrderFile} = this.props;
        generateUploadedFile(file.id, isOriginatorAttachedFile, isOrderFile)
            .then(response => {
                // const win = window.open(response.link, "_blank");
                // win.focus();
            })
            .catch(error => {
                displayGenericError(error);
            });
    };

    handleRemove = (file) => {
        // const {handleRemoveFile, file, type, index, itemId} = this.props;
        this.props.handleRemoveFile(file);
    };

    render() {
        const {title, style, files, disabled, children} = this.props;

        return (
            <div className="upload-wrapper" style={style}>
                <Row gutter={24}>
                    <Col md={16}>
                        <Text className="form-title">
                            {title} {children}
                        </Text>
                        <div style={{display: "flex", flexFlow: "row wrap"}}>
                        {files && files.length > 0 && (files.map(file => {
                                return (
                                    <>
                                        <div style={{display: "inline-block", marginTop: 8}}>
                                        <div className="uploaded-wrapper-sm" style={{margin: 2}}>
                                            <a style={{wordBreak: "break-all", color: "#0A9EB2"}} className="uploaded-file-name" onClick={() => this.handleDownload(file)}>
                                                {file.name}
                                            </a>
                                            <div className="uploaded-action-wrapper">
                                                <div style={{marginTop: 3}}>
                                                    {!disabled && <Icon type="close" onClick={() => this.handleRemove(file)}/>}
                                                    {disabled && (
                                                        <Icon
                                                            component={() => <DownloadIcon/>}
                                                            onClick={() => this.handleDownload(file)}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <Text className="uploaded-file-size" style={{marginLeft: 2}}><FormattedMessage id="app.modal.uploadwrapper.filesize"/>{(!file.size || isNaN(file.size)) ? "" : Math.round(file.size) + "KB"}</Text>
                                        </div>
                                    </>
                                )
                            })
                        )}
                        </div>
                    </Col>
                        <Col md={8}>
                            <Dragger
                                disabled={disabled}
                                accept={this.props.fileExtension || ".pdf,image/*,.doc,.docx"}
                                beforeUpload={this.handleBeforeUpload}
                                name="file"
                                customRequest={this.handleUpload}
                                showUploadList={false}
                            >
                                <UploadIcon style={{verticalAlign: "middle", marginLeft: "15px", marginRight: "15px"}}/>
                                <div style={{marginTop: "3px", marginLeft: "15px", marginRight: "15px"}}>
                                    <Text style={{fontSize: "13px"}}><FormattedMessage
                                        id="app.modal.uploadwrapper.dragyourfile"/></Text>
                                </div>
                            </Dragger>
                    </Col>
                </Row>
            </div>
        );
    }
}

UploadWrapperMulti.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    style: PropTypes.object
};

export default UploadWrapperMulti;
